import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

/** Id of the synthetic row that groups activities not linked to any key initiative. */
export const NO_INITIATIVE_ROW_ID = 'no-initiative'

export type TMdfInitiativeGroupRowType = 'initiative' | 'noInitiative'

export interface IMdfInitiativeGroupRow {
  id: string | number
  name: string
  activityCount: number
  activities: IMdfActivity[]
  planned: number
  requested: number
  paid: number
  /**
   * Requested / planned coverage in percent. `null` when coverage is not
   * applicable (e.g. the "No initiative" row, which has no planned funds).
   */
  coveragePercent: number | null
  rowType: TMdfInitiativeGroupRowType
}

/**
 * Grand totals rendered in the table footer. `null` coverage when there are no
 * planned funds to cover against.
 */
export interface IMdfInitiativeGroupTotal {
  planned: number
  requested: number
  paid: number
  coveragePercent: number | null
}
